const debounce = function(func, wait, immediate) {
    let timeout;

    return function(...params) {
        const later = () => {
            timeout = null;
            if (!immediate) func.apply(this, params);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(this, params);
    };
};

const chunk = (array, size) => {
    if (!array) return [];
  const firstChunk = array.slice(0, size);
  if (!firstChunk.length) {
      return array;
  }
  return [firstChunk].concat(chunk(array.slice(size, array.length), size)); 
}

export {
    debounce,
    chunk,
}